const localization = {
  nl: {
    title: 'Tot binnenkort in de Vulkaaneifel?',
    button: 'Boek uw verblijf via Micazu',
    shareText: 'Of deel met uw gezelschap',
    shareLinks: {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ferienhaus-vek.nl',
      twitter: 'https://twitter.com/home?status=Ferienhaus%20Vulkaneifel%20Kopp%20-%20Een%20thuis,%20weg%20van%20huis,%20voor%20grote%20gezelschappen%20-%20https%3A//www.ferienhaus-vek.nl',
      whatsapp: 'whatsapp://send?text=Ferienhaus Vulkaneifel Kopp - Een thuis, weg van huis, voor grote gezelschappen - https://www.ferienhaus-vek.nl',
      mail: 'mailto:?subject=Ferienhaus%20Vulkaneifel%20Kopp&body=%5BEigen%20tekst%5D%0A%0AFerienhaus%20Vulkaneifel%20Kopp%0AEen%20thuis%2C%20weg%20van%20huis%2C%20voor%20grote%20gezelschappen%0Ahttps%3A%2F%2Fwww.ferienhaus-vek.nl'
    }
  },
  de: {
    title: 'Bis bald in der Vulkaneifel?',
    button: 'Buchen Sie Ihren Aufenthalt mit Micazu',
    shareText: 'Oder teile mit Ihre Freunden und Familie',
    shareLinks: {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ferienhaus-vek.de',
      twitter: 'https://twitter.com/home?status=Ferienhaus%20Vulkaneifel%20Kopp%20-%20Ein%20zweites%20Zuhause%20f%C3%BCr%20gro%C3%9Fe%20Gruppen%20-%20https%3A//www.ferienhaus-vek.de',
      whatsapp: 'whatsapp://send?text=Ferienhaus Vulkaneifel Kopp - Ein zweites Zuhause für große Gruppen - https://www.ferienhaus-vek.de',
      mail: 'mailto:?subject=Ferienhaus%20Vulkaneifel%20Kopp&body=%5BEigene%20Nachricht%5D%0A%0AFerienhaus%20Vulkaneifel%20Kopp%0AEin%20zweites%20Zuhause%20f%C3%BCr%20gro%C3%9Fe%20Gruppen%0Ahttps%3A%2F%2Fwww.ferienhaus-vek.de'
    }
  },
  en: {
    title: 'See you soon in the Vulkaneifel?',
    button: 'Book your stay through Micazu',
    shareText: 'Or share with your friends and family',
    shareLinks: {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.ferienhaus-vek.de',
      twitter: 'https://twitter.com/home?status=Ferienhaus%20Vulkaneifel%20Kopp%20-%20A%20home%20away%20from%20home%20for%20large%20groups%20-%20https%3A//www.ferienhaus-vek.de',
      whatsapp: 'whatsapp://send?text=Ferienhaus Vulkaneifel Kopp - A home away from home for large groups - https://www.ferienhaus-vek.de',
      mail: 'mailto:?subject=Ferienhaus%20Vulkaneifel%20Kopp&body=%5BOwn%20message%5D%0A%0AFerienhaus%20Vulkaneifel%20Kopp%0AA%20home%20away%20from%20home%20for%20large%20groups%0Ahttps%3A%2F%2Fwww.ferienhaus-vek.de'
    }
  }
}

export default localization



// WEBPACK FOOTER //
// ./src/components/CTA/localization.js